import { HttpError } from './http.error';

export class UnauthorisedError extends HttpError {}
